import { templateGridSmartViews } from '../../../../grid/gridSmartViews/view/template';

export const templateIntegrityMonitorRulesSmartViews = document.createElement('template');

templateIntegrityMonitorRulesSmartViews.innerHTML = templateGridSmartViews.innerHTML;
